import styled from 'styled-components';

export const CardContent = styled.div`
  padding: 16px;
  flex: 1;
`;

export default {};
